import { UUID } from "shared-ts/classes/uuid"
import { WebUrl } from "shared-web/lib/webUrl"

export function adminFinancesInternal(): WebUrl {
  return {
    pathname: "/admin/finances/internal",
  }
}

export function adminFinancesExternal(): WebUrl {
  return {
    pathname: "/admin/finances/external",
  }
}

export function adminFinancesExternalTransaction(id: UUID | undefined): WebUrl {
  return {
    pathname: "/admin/finances/external",
    query: id ? { id: id.toString() } : undefined,
  }
}

export function adminFinancesInternalTransaction(
  id: string | undefined
): WebUrl {
  return {
    pathname: "/admin/finances/internal",
    query: id ? { id } : undefined,
  }
}
